<style lang="scss" src='./SignIn.scss' scoped></style>
<template src="./SignIn.html"></template>

<script>
  import {
    mapState,
    mapActions,
    mapMutations
  } from "vuex";
  import InputPassword from '@/components/inputPassword/InputPassword'
  export default {
    name: "SignIn",
    components: {
      InputPassword,
    },
    data() {
      return {
        status: null,
        customer: {
          phone: null,
          password: null,
        },
        loading: false,
      };
    },
    computed: {
      ...mapState(['user']),
    },

    watch: {
      '$route': {
        handler: function (route) {
          if( route.path == '/payment/signin'){
            if (this.user && this.user.customer_id) {
              this.$router.go(-1);
            } 
          }
        },
        deep: true,
        immediate: true
      }
    },

    methods: {
      ...mapActions(['fnApiLogin']),
      async fnValidate() {
        if (await this.$refs['formSignin'].validate()) {
          this.loading = true;
          await this.fnApiLogin({...this.customer, redirect: this.$route.query.redirect });
          this.loading = false;
        }
      },
      fnRestrictChars($event) {
        if ($event.charCode === 0 || /\d/.test(String.fromCharCode($event.charCode))) {
          return true
        } else {
          $event.preventDefault();
        }
      },
    },

    beforeCreate() {},

    created() {
      window.fbq('track', 'PageView');
    },

    mounted() {},

    beforeDestroy() {

    },
  };

</script>
